import RandingStyle7 from "../../randing/RandingStyle7";

function Randing057({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle7
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/016/241118_01.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/057/20250103_01.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/016/241118_03.png`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/016/241118_04.jpg`} //질문 이미지
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/016/241118_05.png`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/016`} //필수!
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing057;
